export default __webpack_public_path__ + "static/media/exclamation-mark.dd5f6cc6.svg";